const footer = {
  copyright:
    '© icdesign 2025 <a href="https://beian.miit.gov.cn/"><span>沪ICP备2021031452号</span></a>',
  beian: "",
};
export default footer;
